import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React, { FormEventHandler, useState } from 'react';

interface EmulateAccessPointManualInputProps {
    loading: boolean;
    onError: React.Dispatch<React.SetStateAction<string | null>>;
    onKeyDown: () => void;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    onSuccess: (arg: string) => void;
    translations: Record<string, string>;
}

export const EmulateAccessPointManualInput: React.FC<EmulateAccessPointManualInputProps> = ({
    loading,
    onError,
    onKeyDown,
    onSuccess,
    setLoading,
    translations,
}) => {
    const [accessPointCode, setAccessPointCode] = useState('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onKeyDown();
        setAccessPointCode(event.target.value.toUpperCase().trim());
        onError(null);
    };

    const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();

        if (accessPointCode.length) {
            onSuccess(accessPointCode);
            setLoading(true);
        }
    };

    return (
        <Box mb={2}>
            <form onSubmit={handleSubmit}>
                <Box my={2}>
                    <TextField
                        id="inputAccessPoint"
                        fullWidth
                        label={translations.GLOBAL_ACCESS_POINT_CODE_LABEL}
                        value={accessPointCode}
                        onChange={handleChange}
                    />
                </Box>
                <Button
                    id="submitAccessPoint"
                    fullWidth
                    disabled={loading || !accessPointCode.length}
                    type="submit"
                    variant="contained"
                    color="primary"
                >
                    {translations.GLOBAL_SUBMIT_BUTTON}
                </Button>
            </form>
        </Box>
    );
};
